import Axios from 'configs/Axios';
import { GlobalAttributesResponse } from 'types/common';

export const getAllGlobalAttributes = () =>
  Axios.get<GlobalAttributesResponse>(`/globalAttribute`);
